<!-- * @author Priya Murpani -->
<!-- *  @created 2026-01-11-->
<!-- Added by Amisha on 05/25/2026.
Reason: provide a unique page root so the applicant search field can be styled locally
without affecting shared filter-builder usage on other pages. -->
<div
  class="main-application-container my-applications-root"
  [class.no-scroll]="isOverlayOpen"
>
   <div
    class="application-overlay"
    *ngIf="isOverlayOpen"
    #overlayContainer
    [class.enable-scroll]="isPrintSummaryOverlay"
  >
    <router-outlet></router-outlet>
  </div>

    <div class="my-applications-content"  [class.hidden]="isOverlayOpen">

  <wm-applicant-home-drawer-heading
    [data]="{
      header: 'My Applications',
      subHeader:
        'Track your applications with quick summary cards and a detailed data table view'
    }"
  ></wm-applicant-home-drawer-heading>
  <wm-summary-card></wm-summary-card>
<div class="application-container"    
> 
   <div *ngIf="isAttachmentOpen">
      <div class="attachments-overlay">
        <div class="attachments-panel" #attachmentsPanel>
          <wm-application-required-documents
            *ngIf="isAttachmentOpen"
            [applicationId]="currentAttachmentApplicationId"
            (close)="handleClose()"
          ></wm-application-required-documents>
        </div>
      </div>
    </div>
  </div>

  <!-- Chat window (uncomment when you have the chat component) -->

  <!-- Added by Amisha on 2026-09-09.
  Reason: pass applicant attempts to open a different chat into the shared visual attention behavior. -->
  <wm-chat-window
    *ngIf="showChat"
    (closed)="handleChatClosed()"
    (messageSent)="handleChatMessageSent($event)"
    [applicationId]="selectedApplicationId"
    [attentionTrigger]="chatAttentionTrigger"
    (errorOccurred)="openErrorModal($event)"
  >
  </wm-chat-window>

  <div style="position:relative" #myAppContainer>
    <wm-filter-builder
      *ngIf="filtersReady"
      id="myApplicationsFilters"
      [params]="filterCriteria"
      [defaultFilters]="defaultFilters"
      [filterTypes]="filterTypes"
      [savedFilters]="true"
      (filtersChange)="filtersChanged($event)"
      [useMuiLayout]="true"
      [showSimpleSearch]="showSimpleSearch"
      [simpleSearchTitle]="simpleSearchTitle"
      [isNoData]="isNoData"
      [hasFewData]="hasFewData"
    >
      <ng-template #sortByTemplate>
        <div class="sort-content">
          <div class="sort-by-wrapper" #sortWrapper>
            <button class="sort-btn" type="button" (click)="toggleSort($event)">
              Sort by |
              <span class="selected-sort-label">
                {{ selectedSortLabel }}
              </span>

              <span class="material-icons dropdown-icon">
                keyboard_arrow_down
              </span>
            </button>

            <div class="sort-menu" *ngIf="isSortOpen">
              <div
                class="sort-item"
                *ngFor="let item of SortByOptions"
                [class.active]="item === selectedSortOption"
                (click)="selectSort(item)"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <wm-common-icon
            [data]="{ iconName: 'more_vert' }"
            class="more-vert-icon"
            (click)="openGlobalColumnMenu()"
          ></wm-common-icon>
        </div>
      </ng-template>
    </wm-filter-builder>

    <!-- end by priya 04-02-2026 -->
    <!-- added by priya 04-02-2026 -->
    <div #appViewAnchor class="app-view-anchor"></div>

    <div class="overlay" *ngIf="showOverlay"></div>

    <div class="panel" *ngIf="showOverlay">
      <router-outlet></router-outlet>
    </div>

    <div class="table-container">
      <!-- Added by amisha on 05/07/2027 to configure row-level keyboard focus specifically for My Applications.
       Reason: this page should highlight and activate entire rows, skip header focus, and keep pagination behavior separate. -->
      <wm-common-table
        #commonTable
        [tableType]="'Applicant'"
        [isLoading]="isLoading"
        [errorMessage]="errorMessage"
        [loadingDataForApplication]="loadingDataForApplication"
        [columns]="columns"
        [displayedColumns]="displayedColumns"
        [data]="data"
        (rowClick)="openDetails($event)"
        (iconClick)="handleIconClick($event)"
        (sortChanged)="onSortChanged($event)"
        [serverSidePagination]="true"
        [totalPages]="pageCount"
        [currentPage]="page"
        [pageSize]="pageSize"
        (pageChange)="onPageChange($event)"
        (rowsPerPageChange)="onRowsPerPageChange($event)"
        (displayedColumnsChange)="onDisplayedColumnsChange($event)"
        [persistColumns]="false"
        [loaderType]="'Skeleton'"
        [enableCellKeyboardFocus]="false"
        [cellKeyboardFocusMode]="'none'"
        [focusableCellKeys]="focusableMyApplicationsColumnKeys"
        [disableHeaderKeyboardFocus]="true"
        [enableRowKeyboardFocus]="true"
        [rowKeyboardFocusable]="isMyApplicationsRowKeyboardFocusable"
        expansionMode="overlay"
        (retry)="onRetry()"
        [showRowsPerPage]="true"
        [showTotalRecords]="true"
        [totalRecords]="totalRecords"
        [pageSizeStorageKey]="'applicant-applications-janus'"
      >
      </wm-common-table>
    </div>
  </div>
  </div>
  <!-- end by priya 04-02-2026 -->
    <div class="arrow-container" *ngIf="showScrollTopBtn">
    <wm-common-icon
      class="arrow-icon"
      [data]="{ iconName: arrowUpwardIcon }"
      (click)="scrollToAbove()"
    ></wm-common-icon>
  </div>
  <wm-common-confirmation-modal
    *ngIf="showErrorModal"
    [data]="errorModalConfig"
    (onOkClick)="showErrorModal = false"
    (onCloseClick)="showErrorModal = false"
  >
  </wm-common-confirmation-modal>
</div>
